import { render } from "./Messages.vue?vue&type=template&id=300fe35a&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=300fe35a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-300fe35a"

export default script